module.exports = __webpack_public_path__ + "static/media/logo.57e15bb1.png";